import React, { useRef } from 'react';

const VisualizarPdfModal = ({ pdfUrl, onClose }) => {
  const iframeRef = useRef(null);

  const handleImprimir = () => {
    if (iframeRef.current && iframeRef.current.contentWindow) {
      try {
        iframeRef.current.contentWindow.print();
      } catch (e) {
        const win = window.open(pdfUrl, '_blank');
        if (win) win.print();
      }
    } else {
      const win = window.open(pdfUrl, '_blank');
      if (win) win.print();
    }
  };

  const handleBaixar = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.setAttribute('download', `documento_${Date.now()}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleCompartilhar = async () => {
    const fullUrl = pdfUrl.startsWith('http') ? pdfUrl : `${window.location.origin}${pdfUrl}`;
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Documento VETIM',
          text: 'Confira este documento da negociação.',
          url: fullUrl
        });
      } catch (e) {
        if (e.name !== 'AbortError') {
          navigator.clipboard.writeText(fullUrl);
          alert('Link copiado para a área de transferência!');
        }
      }
    } else {
      navigator.clipboard.writeText(fullUrl);
      alert('Link copiado para a área de transferência!');
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15, 23, 42, 0.75)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: '16px', boxSizing: 'border-box' }}>
      <div style={{ background: '#ffffff', borderRadius: '16px', width: '100%', maxWidth: '960px', height: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)', overflow: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc' }}>
          <div>
            <h2 style={{ margin: 0, fontSize: '1.2rem', fontWeight: '800', color: '#0f172a' }}>📄 Visualização de Documento</h2>
            <span style={{ fontSize: '0.8rem', color: '#64748b' }}>Visualize, imprima, baixe ou compartilhe o documento</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <button 
              onClick={handleImprimir}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 12px', background: '#f1f5f9', color: '#334155', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer' }}
              title="Imprimir"
            >
              🖨️ Imprimir
            </button>
            <button 
              onClick={handleBaixar}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 12px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer' }}
              title="Baixar"
            >
              ⬇️ Baixar
            </button>
            <button 
              onClick={handleCompartilhar}
              style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 12px', background: '#059669', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '0.8rem', fontWeight: '600', cursor: 'pointer' }}
              title="Compartilhar"
            >
              📤 Compartilhar
            </button>
            <button 
              onClick={onClose}
              style={{ background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer', color: '#64748b', fontWeight: '700', padding: '4px 8px', marginLeft: '8px' }}
              title="Fechar"
            >
              ✕
            </button>
          </div>
        </div>

        <div style={{ flex: 1, background: '#e2e8f0', padding: '12px', display: 'flex', overflow: 'hidden' }}>
          <iframe
            ref={iframeRef}
            src={pdfUrl}
            style={{ width: '100%', height: '100%', border: 'none', borderRadius: '8px', background: '#fff' }}
            title="Visualizador de Documento"
          />
        </div>
      </div>
    </div>
  );
};

export default VisualizarPdfModal;
